import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  style: {"'position":"relative","display":"inline-block","vertical-align":"middle"},
  src: "/img/info.svg",
  alt: "Info"
}, null, -1)

import {Tippy} from "vue-tippy";
import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
  content: {
    type: String,
    required: true,
  }
},
  setup(__props) {

const props = __props

const content = ref(props.content)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Tippy), { content: content.value }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["content"]))
}
}

})